import { createSelector } from "reselect";
import moment from "moment";
import "moment/locale/es";
import { ROLES_RAW } from "../../constants/permissions";
moment().locale("es");

/* APP */
export const isUserAuthorized = createSelector(
  (state) => state.authorization,
  (authorization) => authorization
);
export const getCurrentRoute = createSelector(
  (state) => state.currentRoute,
  (currentRoute) => currentRoute
);
export const getCurrentRouteTitle = createSelector(
  getCurrentRoute,
  (route) => route.title
);
export const getSideMenuState = createSelector(
  (state) => state.app,
  (app) => app.isCollapsedSideMenu
);
export const getCurrentTheme = createSelector(
  (state) => state.currentTheme,
  (currentTheme) => currentTheme
);

/* PROFILE */
export const getUserProfile = createSelector(
  (state) => state.profile,
  (profile) => profile
);
export const currentUserId = createSelector(
  (state) => state.profile,
  (profile) => profile && profile.id
);
export const getCurrentUserRole = createSelector(getUserProfile, (profile) =>
  !profile ? null : (ROLES_RAW.includes(profile.role) ? profile.role : null)
);

/* NOTIFICATIONS STATE */
export const getNotificationsState = createSelector(
  (state) => state.notifications,
  (notifications) => notifications
);

/* USERS */
export const getUsers = createSelector(
  (state) => state.users,
  (users) => users
);
export const getUsersForm = createSelector(
  (state) => state.usersForm,
  (form) => form
);

/* ALERT */
export const getAlerts = createSelector(
  (state) => state.alerts,
  (alerts) => alerts
);
export const getAlertsForm = createSelector(
  (state) => state.alertsForm,
  (form) => form
);

/* PLAYERS */
export const getPlayers = createSelector(
    (state) => state.players,
    (players) => players
);
export const getPlayersForm = createSelector(
    (state) => state.playersForm,
    (form) => form
);

/* DECKS */
export const getDecks = createSelector(
    (state) => state.decks,
    (decks) => decks
);
export const getDecksForm = createSelector(
    (state) => state.decksForm,
    (form) => form
);

/* DECKTYPES */
export const getDeckTypes = createSelector(
    (state) => state.deckTypes,
    (deckTypes) => deckTypes
);
export const getDeckTypesForm = createSelector(
    (state) => state.deckTypesForm,
    (form) => form
);

/* DAYS */
export const getDays = createSelector(
    (state) => state.days,
    (days) => days
);
export const getDaysForm = createSelector(
    (state) => state.daysForm,
    (form) => form
);

/* ROUNDS */
export const getRounds = createSelector(
    (state) => state.rounds,
    (rounds) => rounds
);
export const getRoundsForm = createSelector(
    (state) => state.roundsForm,
    (form) => form
);

/* GAMES */
export const getGames = createSelector(
    (state) => state.games,
    (games) => games
);
export const getGamesForm = createSelector(
    (state) => state.gamesForm,
    (form) => form
);

/* DECKPLAYEDS */
export const getDeckPlayeds = createSelector(
    (state) => state.deckPlayeds,
    (deckPlayeds) => deckPlayeds
);
export const getDeckPlayedsForm = createSelector(
    (state) => state.deckPlayedsForm,
    (form) => form
);

/* PLACARDS */
export const getPlacards = createSelector(
    (state) => state.placards,
    (placards) => placards
);
export const getPlacardsForm = createSelector(
    (state) => state.placardsForm,
    (form) => form
);

/* UPLOADEDDECKS */
export const getUploadeddecks = createSelector(
    (state) => state.uploadeddecks,
    (uploadeddecks) => uploadeddecks
);
export const getUploadeddecksForm = createSelector(
    (state) => state.uploadeddecksForm,
    (form) => form
);

/* SPECIALDAYS */
export const getSpecialdays = createSelector(
    (state) => state.specialdays,
    (specialdays) => specialdays
);
export const getSpecialdaysForm = createSelector(
    (state) => state.specialdaysForm,
    (form) => form
);

/* FORFUNDAYS */
export const getForfundays = createSelector(
    (state) => state.forfundays,
    (forfundays) => forfundays
);
export const getForfundaysForm = createSelector(
    (state) => state.forfundaysForm,
    (form) => form
);

/* SEASONS */
export const getSeasons = createSelector(
    (state) => state.seasons,
    (seasons) => seasons
);
export const getSeasonsForm = createSelector(
    (state) => state.seasonsForm,
    (form) => form
);
